/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  // Distinct values for a Claudia-mirror Advanced Filter dropdown (ab_key,
  // resolution_reason, topic, flow_session_id, used_sections). Returns
  // [{ id, name }] scoped to the account's mirror conversations.
  getFilterOptions(field) {
    return axios.get(`${this.url}/filter_options`, { params: { field } });
  }
}

export default new ConversationApi();
